<template>
  <v-card>
    <v-card-title>
      <v-avatar size=48>
        <v-icon color="primary" large>ballot</v-icon>
      </v-avatar>
      <span class="subheading text-uppercase pl-2">
        Create a new project
      </span>
    </v-card-title>

    <v-card-text class="pt-0">
      <v-form ref="form">
        <v-text-field
          v-model="localProject.name"
          label="Name"
          name="name"
          prepend-icon=" "
          :rules="[rules.required]"
        ></v-text-field>

        <v-textarea
          label="Description"
          name="description"
          class="mt-2"
          prepend-icon="short_text"
          :maxlength="maxCharacters"
          :counter="maxCharacters"
          v-model="localProject.description"
        ></v-textarea>

        <v-spacer></v-spacer>
        <v-layout row>
          <v-flex :style="'background: url(' + logoUrl + ') no-repeat center;'" >
            <vue-dropzone ref='logoDropzone' id='dropzone' :options='dropzoneOptions' @vdropzone-queue-complete="dzQueueComplete" style="opacity: 0.9;"></vue-dropzone>
          </v-flex>
        </v-layout>

      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancel()">Cancel</v-btn>
      <v-btn color="primary" @click="saveProject()" :disabled="!localProject.name || busy" :loading="busy">Create Project</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'

  import vueDropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  import projectService from '@/services/project'

  export default {
    name: 'project-new',

    data () {
      return {
        auth: authentication,
        localProject: {},
        maxCharacters: 100,
        dropzoneOptions: {
          url: 'unknown', // Set this once the project is saved
          method: 'put',
          paramName: 'project[logo]',
          thumbnailWidth: 150,
          maxFilesize: 5.0,
          maxFiles: 1,
          acceptedFiles: 'image/*',
          headers: {
            'X-User-Email': authentication.username(),
            'X-User-Token': authentication.token()
          },
          dictDefaultMessage: 'Pick your project logo',
          // we dnot want DZ to auto-upload the files, we need to make sure it saves first
          autoProcessQueue: false
        },
        busy: false,
        rules: {
          required: value => !!value || 'Required'
        }
      }
    },

    components: {
      vueDropzone
    },

    computed: {
      logoUrl () {
        return require('@/assets/largeicon.png')
      }
    },

    mounted () {
    },

    methods: {
      cancel () {
        this.$refs.form.reset()
        EventBus.$emit('project-created')
      },

      saveProject () {
        if (this.$refs.form.validate()) {
          this.busy = true
          projectService.create(
            (data) => {
              this.localProject = Object.assign({}, data.attributes)

              this.$refs.logoDropzone.setOption('url', process.env.API_URL + data.links.update_uri + '.json')

              if (this.$refs.logoDropzone.getQueuedFiles().length > 0) {
                this.$refs.logoDropzone.processQueue()
              } else {
                // no files queued, so just pretend we are done
                this.dzQueueComplete()
              }
            },
            (err) => {
              this.busy = false
              console.log(err)
            },
            this.localProject
          )
        }
      },

      dzQueueComplete (file, xhr, formData) {
        this.$refs.logoDropzone.removeAllFiles()
        // NOTE: there is a catch here: when we save the project we get the links to the OLD images. We need to reload the project once the new image is saved, so we
        // can send that back and the caller does not have to deal with it.
        projectService.show(
          (data) => {
            this.busy = false
            this.$refs.form.reset()
            EventBus.$emit('project-created', data)
            this.localProject = Object.assign({}, null)
          },
          (err) => {
            console.log(err)
          },
          this.localProject.id
        )
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/_new.vue